export const apiHost = process.env.VUE_APP_BASE_API 
export const apiFms = process.env.VUE_APP_FMS_API 

// export const newPlatform = process.env.NODE_ENV === 'test' ? 'http://192.168.3.197:8080' : 'http://192.168.3.155:8080';
export const newPlatform = process.env.VUE_APP_NEW_VEIBAN_HOST

export const oldPlatform = process.env.VUE_APP_OLD_VEIBAN_BHOST